import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { routes } from './app.routes';
import { ConnectionModule, CoreModule, StoreModule } from '@softline/core';
import { environment } from '../environments/environment';
import {
  AuthenticationModule,
  AuthorizationModule,
  JwtAuthenticationModule,
} from '@softline/auth';
import {
  AppearanceModule,
  ApplicationModule,
  ConsoleModule,
  DeveloperModule,
  ItemScanModule,
  MasterDataModule,
  OfflineModule,
  provideDarkTheme,
  remoteConfigProviders,
} from '@softline/application';
import { DynamicModule } from '@softline/dynamic';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { loginProviders } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { inventurProviders } from '@softapps/mde/inventur';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { SoftappsCoreModule } from '@softapps/core';
import { stempelerfassungProviders } from '@softapps/pms/stempelerfassung';
import {
  pmsStempelTerminalProviders,
  SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG,
} from '@softapps/pms/stempel-terminal';
import { provideUiCore } from '@softline/ui-core';
import { provideStorageLocation } from '@softapps/mde/storage-location';

export const appConfig: ApplicationConfig = {
  providers: [
    provideUiCore(),
    importProvidersFrom(
      BrowserAnimationsModule,
      RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),

      // Framework
      CoreModule.forRoot(),
      StoreModule.forRoot(),
      ConnectionModule.forRoot(environment.connection),
      AuthenticationModule.forRoot(),
      JwtAuthenticationModule.forRoot(),
      AuthorizationModule.forRoot(),
      ApplicationModule.forRoot(),
      AppearanceModule.forRoot(),
      DynamicModule.forRoot(),
      MasterDataModule.forRoot(),
      DeveloperModule.forRoot(),
      ConsoleModule.forRoot(),
      ItemScanModule.forRoot(),
      OfflineModule.forRoot(),
      SoftappsCoreModule.forRoot()
    ),

    provideDarkTheme(false),

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,

    // MDE
    ...wwsCoreProviders,

    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...inventurProviders,
    ...warenverprobungProviders,
    ...retourenProviders,
    ...provideStorageLocation(),

    ...artikelInfoProviders,

    {
      provide: SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG,
      useValue: {
        dashboardInfo: {
          title: 'Lagerhaus Schaerding',
          subtitle: 'Stempelterminal',
        },
      },
    },

    ...pmsStempelTerminalProviders,

    ...stempelerfassungProviders,

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
